import {castArray} from '@coolcolduk/util';
import {FeatureObject} from '../../types/FeatureObject';

/**
 * Filter features by excluded Tagses
 * @param excludeTags
 * @returns
 */
export function filterByExcludeTags(excludeTags?: string[] | string): (f: FeatureObject) => boolean {
  return (f) => !excludeTags || !castArray(excludeTags).some((tag) => f.tags?.includes(tag));
}
